/**
 * The listeners `onSocketClosed` registers and `notifySocketClosed` calls. Both files share this one set, so it is
 * deliberately left out of the directory's `index.ts`.
 */
export const socketClosedListeners = new Set<() => void>()
